@if (videos?.length > 0) {
  <div class="media-playlist">
    @if (!isPrevDisabled && videos?.length > visibleItems) {
      <button class="prev" [style.top.%]="buttonTopPercent" (click)="prev()">
        <i class="material-symbols-outlined">chevron_left</i>
      </button>
    }
    <div class="playlist" #carousel>
      <div class="track" #track>
        <div
          class="media-item item"
          *ngFor="let video of videos; let i = index"
          (click)="onPlaylistSelect(video, i)"
          [class.selected]="selectedIndex === i"
          #item
        >
          <div class="media-thumbnail">
            <div class="play-button">
              @if (selectedIndex === i) {
                <div class="now-playing">{{ 'fgb.media.now.playing' | translate }}</div>
              } @else {
                <div class="play-icon">
                  <i class="material-symbols-outlined">play_arrow</i>
                </div>
              }
            </div>
            <div class="thumbnail-overlay"></div>
            <img [src]="video.Image | contentImage: '6'" alt="" draggable="false" />
          </div>
          <div class="media-title">{{ video.Title }}</div>
        </div>
      </div>
    </div>
    @if (!isNextDisabled) {
      <button class="next" [style.top.%]="buttonTopPercent" (click)="next()">
        <i class="material-symbols-outlined">chevron_right</i>
      </button>
    }
  </div>
}
